import { render, staticRenderFns } from "./LoveTabs.vue?vue&type=template&id=4b4ab65e&scoped=true"
import script from "./LoveTabs.js?vue&type=script&lang=js&external"
export * from "./LoveTabs.js?vue&type=script&lang=js&external"
import style0 from "./LoveTabs.scss?vue&type=style&index=0&id=4b4ab65e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ab65e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Icon/Icon.vue').default})
